var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarMagnifierIconcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  fill: "currentColor"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M44.472.585c24.234 0 43.884 19.65 43.884 43.887 0 24.234-19.65 43.884-43.884 43.884-24.237 0-43.887-19.65-43.887-43.884C.585 20.235 20.235.585 44.472.585z",
  id: "cmi-a"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-40)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M191 57c0 31.48-25.52 57-57 57S77 88.48 77 57s25.52-57 57-57 57 25.52 57 57",
  fill: "#C9E1EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86 56.472C86 28.086 109.09 5 137.47 5c28.382 0 51.471 23.086 51.471 51.472 0 28.383-23.089 51.47-51.47 51.47-28.382 0-51.471-23.087-51.471-51.47z",
  fill: "#CAE1EA"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(93 12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cmi-b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cmi-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#cmi-a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.498 35.426c4.37 5.373 7.813 10.444 7.669 18.62v45.22c0 1.166-.666 2.192-1.64 2.726H33.271c-.974-.534-1.64-1.56-1.64-2.727v-10.45c-28.384 1.287-61.993 1.287-90.377 0v10.45c0 1.16-.665 2.193-1.64 2.727H-86.64c-.974-.534-1.64-1.56-1.64-2.727v-45.22c-.145-8.175 3.299-13.246 7.668-18.619l1.457-1.797c-.35-.704-.727-1.376-1.338-1.672l-10.211-2.228c-2.675-.302-.62-7.215 1.823-7.504l9.086-1.074c1.43-.02 2.405.691 2.733 2.43l.325 3.486 2.643-.026 15.134-19.6c.797-1.029 1.678-1.595 2.97-1.756 26.735-4.221 58.132-4.266 84.867 0 1.293.161 2.174.727 2.971 1.756l15.14 19.606 2.644-.012.318-3.454c.328-1.739 1.302-2.45 2.733-2.43l9.086 1.074c2.444.289 4.498 7.202 1.823 7.504L53.38 31.957c-.617.296-.987.968-1.337 1.672l1.456 1.797z",
  stroke: "#0D4F78",
  strokeWidth: 1.395,
  fill: "#FFF",
  mask: "url(#cmi-b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-72.173 32.693c39.078-2.675 78.153-2.575 117.231.206l-117.23-.206zM50.12 48.631c1.087-.086 1.753.615 1.791 1.672l.138 3.341c.036.7-.408 1.11-1.067 1.373l-5.19 2.048a2.311 2.311 0 0 1-.951.177l-24.404.186c-.691-.006-2.476-.746-2.128-1.543l.839-1.942c.308-.694.816-1.2 1.816-1.331l29.156-3.98zM-58.746 88.816c-6.456-.158-12.793-.865-19.08-1.872l19.08 1.872zm90.378 0c6.45-.158 12.793-.865 19.079-1.872l-19.08 1.872z",
  stroke: "#0D4F78",
  strokeWidth: 1.395,
  fill: "#FFF",
  mask: "url(#cmi-b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M169.359 88.945l.588-.588c2.789-2.783 7.347-2.783 10.13 0l19.7 19.696c-1.789 5.366-5.36 8.935-10.72 10.724l-19.698-19.702c-2.786-2.783-2.786-7.34 0-10.13z",
  stroke: "#0D4F78",
  strokeWidth: 1.395,
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.727 31.548c5.897 6.443 9.502 15.072 9.502 24.557 0 19.953-15.96 36.124-35.642 36.124-16.609 0-30.567-11.515-34.52-27.101M137.2 12.585c24.085 0 43.613 19.528 43.613 43.616 0 24.085-19.528 43.613-43.613 43.613-24.088 0-43.616-19.528-43.616-43.613 0-24.088 19.528-43.616 43.616-43.616zm32.411 76.609l.584-.584c2.765-2.76 7.285-2.76 10.045 0l19.536 19.532c-1.774 5.322-5.316 8.861-10.631 10.635l-19.534-19.538c-2.762-2.76-2.762-7.28 0-10.045z",
  stroke: "#0D4F78",
  strokeWidth: 1.395
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 6,
  cx: 137,
  cy: 56,
  r: 40
})), /*#__PURE__*/React.createElement("path", {
  d: "M-.51 91.124h71.135",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.92 91.462H56.6",
  stroke: "#0D4F78",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.922 96.761H10.184",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.488 99.76H37.235",
  stroke: "#0D4F78",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M30.993 100.759h-8.324",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.073 99.76H24.75",
  stroke: "#0D4F78",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));
export default SvgCarMagnifierIconcom;